import { defineComponent } from 'vue';
export default defineComponent({
  name: 'FeatureCard',
  props: ['icon', 'title', 'desc'],
  setup: function () {
    return {};
  }
});